"use client";
import PageLayout from "@/layouts/pageLayout";
import HeroComponent from "./components/hero";
import IntroComponent from "./components/intro";
import SolutionComponent from "./components/solutions";
import FeaturesComponent from "./components/features";
import UseCasesComponent from "./components/useCases";
import Comparison from "./components/comparison";
import ServicesCards from "./components/services";
import FaqComponent from "./components/faq";

const IaasPage = () => {
  return (
    <PageLayout showCustomers showContactForm spacing={20}>
      <HeroComponent />
      <IntroComponent />
      <SolutionComponent />
      <FeaturesComponent />
      <UseCasesComponent />
      <Comparison />
      <ServicesCards />
      <FaqComponent />
    </PageLayout>
  );
};

export default IaasPage;
